const isValidDate = (d: unknown) =>
  d instanceof Date && !Number.isNaN(d.getTime());

export default isValidDate;
